import $axios from '@/utils/request'

// 获取试卷列表
export function getExamList (data) {
  const url = '/edu/exam/list'
  return $axios.fPost(url, data)
}

// 新增试卷
export function addExam (data) {
  const url = '/edu/exam/add'
  return $axios.fPost(url, data)
}

// 编辑试卷
export function editExam (data) {
  const url = '/edu/exam/edit'
  return $axios.fPost(url, data)
}

// 删除试卷
export function delExam (data) {
  const url = '/edu/exam/del'
  return $axios.fPost(url, data)
}

// 获取试卷详细信息
export function getExamInfo (data) {
  const url = '/edu/exam/getInfo'
  return $axios.fPost(url, data)
}

// 获取学员考试-试卷详细信息
export function getUserExam (data) {
  const url = '/edu/exam/getUserExam'
  return $axios.fPost(url, data)
}

// 批阅试卷
export function examScore (data) {
  const url = '/edu/exam/score'
  return $axios.fPost(url, data)
}

// 批阅试题
export function questionScore (data) {
  const url = '/edu/exam/question/score'
  return $axios.fPost(url, data)
}

// 获取试卷使用次数
export function getUsedTimes (data) {
  const url = '/edu/exam/getUsedTimes'
  return $axios.fGet(url, data)
}
